var api = {};

api.getActive = function(){
    var url = window.sessionStorage.getItem("apiPath")+'/api/institutionCenters/home/activeAlumni?access_token='+window.sessionStorage.getItem("authenticationKey");
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}

api.getAlumni = function(){
    var url = window.sessionStorage.getItem("apiPath")+'/api/institutionCenters/home/alumni?access_token='+window.sessionStorage.getItem("authenticationKey");
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}

api.getEnrollment = function(){
    var url = window.sessionStorage.getItem("apiPath")+'/api/institutionCenters/home/enrollments?access_token='+window.sessionStorage.getItem("authenticationKey");
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}

api.getExtent = function(){
    var url = window.sessionStorage.getItem("apiPath")+'/api/institutionCenters/reports/extent?access_token='+window.sessionStorage.getItem("authenticationKey");
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}

api.getEfficience = function(){
    var url = window.sessionStorage.getItem("apiPath")+'/api/institutionCenters/reports/efficience?access_token='+window.sessionStorage.getItem("authenticationKey");
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}
api.getMentoringData = function(){
    var url = window.sessionStorage.getItem("apiPath")+'/api/mentorings/csv?access_token='+window.sessionStorage.getItem("authenticationKey");    
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}

api.getActiveReport = function(type,period,year,month){    
    var url = window.sessionStorage.getItem("apiPath");
    url = url +'/api/institutionCenters/reports/membershipBy'+period+'/'+type;    
    url = url + '?access_token='+window.sessionStorage.getItem("authenticationKey");
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;
    if(period==="Month"){
        url = url + '&year='+year
    }
    if(period==="Day"){
        url = url + '&year='+year
        url = url + '&month='+month
    }    
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}
api.getStrategicStatus = function(){    
    var url = window.sessionStorage.getItem("apiPath");
    url = url +'/api/institutionCenters/reports/strategic/status';
    url = url + '?access_token='+window.sessionStorage.getItem("authenticationKey");
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}
api.getStrategicIndustry = function(){    
    var url = window.sessionStorage.getItem("apiPath");
    url = url +'/api/institutionCenters/reports/strategic/industry';
    url = url + '?access_token='+window.sessionStorage.getItem("authenticationKey");
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}
api.getStrategicCountry = function(){    
    var url = window.sessionStorage.getItem("apiPath");
    url = url +'/api/institutionCenters/reports/strategic/map';    
    url = url + '?access_token='+window.sessionStorage.getItem("authenticationKey");
    
    var institution = window.sessionStorage.getItem("institution");    
    if(institution && institution!=="null")
        url = url + "&institution="+institution;

    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}
api.getInstitutions = function(){    
    var url = window.sessionStorage.getItem("apiPath");
    url = url +'/api/institutionCenters/institutions';
    url = url + '?access_token='+window.sessionStorage.getItem("authenticationKey");
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}
api.getUpdateData = function(value="", offset=0){    
    var url = window.sessionStorage.getItem("apiPath");    
    url = url +'/api/institutionCenters/updateDate/baseline';
    url = url + '?access_token='+window.sessionStorage.getItem("authenticationKey");
    url = url + '&limit=10&search='+(value?value:"")+'&offset='+offset;    
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
} 
api.getUpdateDataAuthorization = function(){    
    var url = window.sessionStorage.getItem("apiPath");    
    url = url +'/api/baselines/authorizeAll';
    url = url + '?access_token='+window.sessionStorage.getItem("authenticationKey");        
    return fetch(url,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        ).then((response) => response.json());
}        

export default api;


// WEBPACK FOOTER //
// ./src/services/api.js